import React, { useState, useEffect } from "react";
import Header from "./../components/Header";
import LeftNav from "./../components/LeftNav";
import UserService from "../services/UserService";

const ATLAS_URL = process.env.REACT_APP_ATLAS_URL;

const Atlas = () => {
  const [token, setToken] = useState(null);

  useEffect(() => {
    setToken(UserService.getToken ? UserService.getToken() : null);
  }, []);

  return (
    <>
      <LeftNav />
      <div className="main-wrapper">
        <Header token={token} disableSidebarToggle={true} rightNavNavigate={true} />
        <main>
          <div style={{ width: "100%", height: "calc(100vh - 120px)" }}>
            <iframe
              title="Atlas"
              src={ATLAS_URL}
              style={{ width: "100%", height: "100%", border: "none" }}
            />
          </div>
        </main>
      </div>
    </>
  );
};

export default Atlas;
